import { TMessageSchema } from '../../../types/messages';
import { updateMessageFromRaw } from '../../../utils/message/updateMessageFromRaw';
import { TMessagesMap, IParsedMessage } from '../../../utils/messageUtils';

interface IUpdateMessageAndRelatedReplyOptions {
  /** Мапа со всеми загруженными сообщениями в чате */
  messagesMap: TMessagesMap;
  /** Сообщения из стейта открытого чата */
  chatMessages: IParsedMessage[];
  /** Обновляемое сообщение */
  message: TMessageSchema;
  /**
   * Обновляет цитату в сообщении из чата на основании исходного сообщения.
   * - `replyMessage` — сообщение из стора, в котором цитата
   * - `originalMessage` — исходное сообщение
   */
  updateQuote: (replyMessage: IParsedMessage, originalMessage: TMessageSchema) => IParsedMessage;
}

/**
 * @description
 * Обновляет сообщение и цитаты в реплаях, ссылающихся на него.
 */
export function updateMessageAndRelatedReply({
  messagesMap,
  chatMessages,
  message,
  updateQuote,
}: IUpdateMessageAndRelatedReplyOptions): IParsedMessage[] {
  const originalMessageId = message.messageId;

  return chatMessages.map((parsedMessage, messageIndex) => {
    const { reply } = parsedMessage.message;

    if (parsedMessage.messageId === originalMessageId) {
      const nextParsedMessage = {
        ...parsedMessage,
        rawMessage: message,
        message: updateMessageFromRaw(parsedMessage.message, message),
      };

      messagesMap.set(nextParsedMessage.messageId, {
        messageIndex,
        message: nextParsedMessage,
      });

      return nextParsedMessage;
    }

    if (reply && reply.messageId === originalMessageId) {
      const nextParsedMessage = updateQuote(parsedMessage, message);

      messagesMap.set(nextParsedMessage.messageId, {
        messageIndex,
        message: nextParsedMessage,
      });

      return nextParsedMessage;
    }

    return parsedMessage;
  });
}
